module.exports = __webpack_public_path__ + "img/0445_07.76c545c9.jpg";